import { render, staticRenderFns } from "./InboundCall.vue?vue&type=template&id=2c161f3e&"
import script from "./InboundCall.vue?vue&type=script&lang=js&"
export * from "./InboundCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports